import { Tooltip, TooltipProps } from '@mui/material';
import { FC, ReactElement, useEffect, useState } from 'react';
import { COLORS } from 'services/constants/colors';

export interface IEasTooltipProps extends Omit<TooltipProps, 'children'> {
	children: ReactElement;
	type?: 'warning' | 'error' | 'info';
	timeout?: number | null;
}

export const EasTooltip: FC<IEasTooltipProps> = ({
	children,
	type = 'info',
	timeout = null,
	...props
}) => {
	const color =
		type === 'warning' ? COLORS.WARNING : type === 'error' ? COLORS.ERROR : COLORS.PRIMARY;
	const [open, setOpen] = useState(!!timeout);
	useEffect(() => {
		if (timeout) {
			setTimeout(() => {
				setOpen(false);
			}, timeout);
		}
	}, [timeout]);
	return (
		<Tooltip
			{...props}
			open={open}
			onOpen={() => setOpen(true)}
			onClose={() => setOpen(false)}
			arrow
			placement={props.placement || 'top-start'}
			componentsProps={{
				tooltip: {
					sx: {
						backgroundColor: color,
						color: 'white',
						fontSize: '12px',
						opacity: 1,
						'&&&': {
							backgroundColor: color,
						},
					},
				},
				arrow: {
					sx: {
						color: color,
						opacity: 1,
					},
				},
			}}
		>
			{children}
		</Tooltip>
	);
};
